<template>
  <div class="yxtbiz-ote-num-input" @click="focus">
    <span>{{ name }}</span>
    <span class="flex">
      <yxt-input
        size="small"
        v-model="text"
        :maxlength="(max + '').length"
        ref="inputer"
        @change="changeInput"
      ></yxt-input>
    </span>
    <span class="flex flex-vertical">
      <button @click.stop="changeInput(value + 1)">
        <yxt-tooltip
          :disabled="!maxTip ||  value < max"
          :content="maxTip"
          placement="top"
        >
          <yxt-svg
            class="trans-270deg"
            :class="
              value >= max ? 'not-allowed color-gray-4' : 'hover-primary-6 hand'
            "
            width="12px"
            height="12px"
            icon-class="right"
          />
        </yxt-tooltip>
      </button>
      <button @click.stop="changeInput(value - 1)">
        <yxt-svg
          class="trans-90deg"
          :class="
            value <= min ? 'not-allowed color-gray-4' : 'hover-primary-6 hand'
          "
          width="12px"
          height="12px"
          icon-class="right"
        />
      </button>
    </span>
  </div>
</template>

<script>
import { SvgMediaUrl } from '../const';
export default {
  name: 'YxtbizOteTypeSelector',
  components: {},
  props: {
    max: {
      type: Number,
      default: 10
    },
    min: {
      type: Number,
      default: 0
    },
    value: {
      type: String | Number,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    maxTip: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      SvgMediaUrl,
      text: this.value
    };
  },
  created() {},
  methods: {
    changeInput(v) {
      this.text = parseInt(v, 10);
      if (isNaN(this.text)) {
        this.text = this.value;
      }
      if (this.text > this.max) {
        this.text = this.max;
      }
      if (this.text < this.min) {
        this.text = this.min;
      }
      this.$emit('input', this.text);
    },
    focus(event) {
      this.$refs.inputer && this.$refs.inputer.focus();
      event.preventDefault();
    }
  }
};
</script>
